import Vue from 'vue'
import Vuex from 'vuex'
import { mutations } from './mutations'
import * as actions from './actions'

Vue.use(Vuex)

export default (dataState) => {

  const state = {
    barProgress: 0,
    requestError: false,
    submitted: false,
    diagnosis: {
      industry: '',
      firstname: '',
      email: '',
      business_model: '',
      estado_sigla: '',
      company: '',
      numemployees: '',
      td_cargo: '',
      clevel_funcao: '',
      departamento: '',
      papel_td: ''
    },
    userid: '',
    usercode: '',
    username: '',
    questions: {
      cultura_e_lideranca: [
        { field: 'cultura_e_lideranca_1', weight: 1, tag: 'Mindset', title: 'Estou convencido que o processo de transformação digital é um efeito global e impacta não somente empresas, mas o cotidiano das pessoas.' },
        { field: 'cultura_e_lideranca_2', weight: 2, tag: 'Mindset', title: 'Tenho consciência dos fatores que envolvem a transformação digital quando falamos em ferramentas, processos e pessoas.' },
        { field: 'cultura_e_lideranca_3', weight: 2, reverse: true, tag: 'Mindset', title: 'Percebo que as habilidades necessárias para atuar na transformação digital pertecem somente à geração dos Millennials.' },
        { field: 'cultura_e_lideranca_4', weight: 1, reverse: true, tag: 'Inovação', title: 'Prefiro ser reconhecido como um profissional que traz segurança por seguir processos lineares do que como um agente de mudanças disposto a testar novos modelos com frequencia.' },
        { field: 'cultura_e_lideranca_5', weight: 3, tag: 'Liderança', title: 'Identifico com facilidade processos críticos do meu ambiente de trabalho e busco alternativas viáveis em conjunto com a equipe.' },
        { field: 'cultura_e_lideranca_6', weight: 2, tag: 'Mindset', title: 'Costumo interagir com meus colegas de trabalho a fim de compartilhar conhecimentos e favorecer um ambiente de crescimento colaborativo.' },
        { field: 'cultura_e_lideranca_7', weight: 3, reverse: true, tag: 'Liderança', title: 'Na posição de líder, optaria por desenhar estratégias de acordo com padrões analógicos e de conhecimento do time, ao invés de provar modelos digitais ainda não habituais.' },
      ],
      agilidade_operacional: [
        { field: 'agilidade_operacional_1', weight: 3, tag: 'Ferramentas', title: 'Considero frequentemente o uso de ferramentas digitais nos processos operacionais, visando redução de custos, agilidade ou melhor gestão de recursos.' },
        { field: 'agilidade_operacional_2', weight: 2, tag: 'Metodologias ágeis', title: 'Utilizo recursos como mapas mentais para visualizar com mais clareza os pontos de atenção de um projeto.' },
        { field: 'agilidade_operacional_3', weight: 3, tag: 'Ferramentas', title: 'Sempre que possível opto por ferramentas com recursos de automação que possam substituir processos manuais e/ou repetitivos.' },
        { field: 'agilidade_operacional_4', weight: 1, reverse: true, tag: 'Mindset', title: 'Me sinto mais confortável trabalhando em projetos com rotinas fixas e pré-estabelecidas no longo prazo do que com projetos modulares de curta e média duração.' },
        { field: 'agilidade_operacional_5', weight: 2, tag: 'Metodologias ágeis', title: 'Estudo com frequencia métodos e alternativas práticas para implementar mudanças de maneira mais ágil.' },
        { field: 'agilidade_operacional_6', weight: 1, tag: 'Metodologias ágeis', title: 'Em vista de resolver determinados problemas considero viável reunir pessoas de departamentos distintos para formar uma nova equipe.' },
        { field: 'agilidade_operacional_7', weight: 1, reverse: true, tag: 'Mindset', title: 'Percebo que a reavaliação de processos em períodos pré-determinados ocasionam desperdício de tempo e prejudicam a eficiência.' },
      ],
      tecnologia_digital: [
        { field: 'tecnologia_digital_1', weight: 1, tag: 'Análise de dados', title: 'Entendo o impacto que a coleta, estruturação e leitura inteligente de dados podem ocasionar em meu trabalho.' },
        { field: 'tecnologia_digital_2', weight: 3, tag: 'KPI\'s', title: 'Em cada projeto que executo tenho mapeados os indicadores de sucesso das ações.' },
        { field: 'tecnologia_digital_3', weight: 2, tag: 'Cloud computing', title: 'Sei dos benefícios que o armazenamento de dados na nuvem (cloud computing) podem trazer para meu trabalho.' },
        { field: 'tecnologia_digital_4', weight: 1, tag: 'Segurança de dados', title: 'Prezo pela segurança digital dos arquivos que temos armazenados, seguindo as orientações do time de TI.' },
        { field: 'tecnologia_digital_5', weight: 2, reverse: true, tag: 'IoT e Impressão 3D', title: 'Não vejo aplicações reais da Internet das Coisas e da impressão 3D, sendo tecnologias que devem cair em desuso nos próximos anos.' },
        { field: 'tecnologia_digital_6', weight: 3, tag: 'Análise de dados', title: 'Tomo decisões com base em sistemas analíticos, utilizando análise de dados para construção de estratégias.' },
        { field: 'tecnologia_digital_7', weight: 1, reverse: true, tag: 'Gestão da informação', title: 'É melhor controlar as informações da empresa em documentos do Word e planilhas segmentadas do Excel do que compilar tudo em um único ambiente.' },
      ],
      experiencia_do_cliente: [
        { field: 'experiencia_do_cliente_1', weight: 2, tag: 'Metodologias ágeis', title: 'Acredito que testar possíveis soluções para nossos clientes, despendendo recursos em protótipos simplificados, pode tornar nossos produtos mais lucrativos.' },
        { field: 'experiencia_do_cliente_2', weight: 3, tag: 'Personas', title: 'Tenho mapeadas as necessidades das personas da empresa e sei quais soluções oferecer para cada perfil de cliente, aumentando a geração de valor do meu produto.' },
        { field: 'experiencia_do_cliente_3', weight: 3, reverse: true, tag: 'Gamificação', title: 'As dinâmicas de gamificação prejudicam o engajamento dos clientes, geralmente dificultando o processo de retenção.' },
        { field: 'experiencia_do_cliente_4', weight: 2, tag: 'Jornada do Cliente', title: 'Entendo os hábitos de consumo dos meus clientes e levo isso em consideração para proporcionar uma melhor experiência durante a jornada do consumidor.' },
        { field: 'experiencia_do_cliente_5', weight: 2, reverse: true, tag: 'Mindset', title: 'Considero que a preocupação com melhorias no produto dispersa a equipe de pós-vendas.' },
        { field: 'experiencia_do_cliente_6', weight: 1, tag: 'Ferramentas', title: 'O uso de uma plataforma de atendimento omnichannel pode contribuir com o aumento das vendas e/ou retenção de clientes.' },
        { field: 'experiencia_do_cliente_7', weight: 1, tag: 'Análise de dados', title: 'Administrar os dados dos clientes em uma plataforma digital favorece a análise do comportamento do usuário.' },
      ],
      empreendedorismo_digital: [
        { field: 'empreendedorismo_digital_1', weight: 2, tag: 'Empresas digitais', title: 'Do ponto de vista de um negócio digital, entendo com clareza a aplicação dos termos: escala, alcance e velocidade.' },
        { field: 'empreendedorismo_digital_2', weight: 1, tag: 'Disrupção', title: 'Encaro a disrupção como algo natural dos mercados e produtos, sendo uma oportunidade para novas ideias.' },
        { field: 'empreendedorismo_digital_3', weight: 1, reverse: true, tag: 'Crescimento Exponencial', title: 'Prefiro considerar um crescimento linear, onde consigo prever até onde vai o negócio, do que as variáveis para um crescimento exponencial.' },
        { field: 'empreendedorismo_digital_4', weight: 1, tag: 'Parcerias estratégicas', title: 'Procuro expandir minha rede de contatos constantemente, tendo em vista possíveis parcerias estratégicas.' },
        { field: 'empreendedorismo_digital_5', weight: 3, tag: 'Produtividade', title: 'Tenho atenção constante com o meu nível de produtividade, encontrando mecanismos para gestão de tempo e performance.' },
        { field: 'empreendedorismo_digital_6', weight: 2, reverse: true, tag: 'Cultura digital', title: 'Entendo que o desenvolvimento de uma cultura digital dentro do negócio se resume à contratação de ferramentas digitais.' },
        { field: 'empreendedorismo_digital_7', weight: 3, tag: 'Empresas digitais', title: 'Sempre observo o que acontece no mercado como uma maneira de encontrar oportunidades ou prever riscos.' },       
      ]
    },
    cultura_e_lideranca: {
      cultura_e_lideranca_1: 0,
      cultura_e_lideranca_2: 0,
      cultura_e_lideranca_3: 100,
      cultura_e_lideranca_4: 100,
      cultura_e_lideranca_5: 0,
      cultura_e_lideranca_6: 0,
      cultura_e_lideranca_7: 100,
    },
    experiencia_do_cliente: {
      experiencia_do_cliente_1: 0,
      experiencia_do_cliente_2: 0,
      experiencia_do_cliente_3: 100,
      experiencia_do_cliente_4: 0,
      experiencia_do_cliente_5: 100,
      experiencia_do_cliente_6: 0,
      experiencia_do_cliente_7: 0,
    },
    empreendedorismo_digital: {
      empreendedorismo_digital_1: 0,
      empreendedorismo_digital_2: 0,
      empreendedorismo_digital_3: 100,
      empreendedorismo_digital_4: 0,
      empreendedorismo_digital_5: 0,
      empreendedorismo_digital_6: 100,
      empreendedorismo_digital_7: 0,
    },
    tecnologia_digital: {
      tecnologia_digital_1: 0,
      tecnologia_digital_2: 0,
      tecnologia_digital_3: 0,
      tecnologia_digital_4: 0,
      tecnologia_digital_5: 100,
      tecnologia_digital_6: 0,
      tecnologia_digital_7: 100,
    },
    agilidade_operacional: {
      agilidade_operacional_1: 0,
      agilidade_operacional_2: 0,
      agilidade_operacional_3: 0,
      agilidade_operacional_4: 100,
      agilidade_operacional_5: 0,
      agilidade_operacional_6: 0,
      agilidade_operacional_7: 100,
    },
    test_results: {
      cultura_e_lideranca: 0,
      agilidade_operacional: 0,
      tecnologia_digital: 0,
      experiencia_do_cliente: 0,
      empreendedorismo_digital: 0,
      overall: 0,
    },
    understanding: {
      td_understanding: 0,
      td_understanding_corp: 0,
      td_readiness: 0,
      td_investment: 0,
    },
    people: {
      td_maturity: 0,
      td_leadership_buy_in: 0,
      td_value: 0,
      td_employee_readiness: 0,
      td_employee_profile: 0,
      td_communication: 0,
      td_openness: 0,
      td_inovation: 0,
    },
    process: {
      td_tech: 0,
      td_mkt: 0,
      td_hr: 0,
      td_finance: 0,
      td_it: 0,
      td_legal: 0,
      td_goal_setting: 0,
      td_risk_profile: 0,
      td_change: 0,
      td_tooling: 0,
      td_automation: 0,
      td_tech_inovation: 0,
    },
    customer_experience: {
      td_cust_understanding: 0,
      td_cust_focus: 0,
      td_cust_data: 0,
      td_biz_model: 0,
      td_tech_adoption: 0,
      td_experimentation: 0,
      td_digital_delivery: 0,
    },
    strategy: {
      td_strategy_infra: 0,
      td_digital_first: 0,
      td_measurement: 0,
      td_security: 0,
      td_team_readyness: 0,
      td_communication_clarity: 0,
      td_goal_solution: 0,
      td_data_unity: 0,
    },
    results: {
      td_score_understanding: 0,
      td_score_people: 0,
      td_score_process: 0,
      td_score_customer_experience: 0,
      td_score_strategy: 0,
      td_score_overall: 0,
    },
    ...dataState
  }

  const getters = {
    data: () => {
      const questions = {
        ...state.understanding,
        ...state.people,
        ...state.process,
        ...state.customer_experience,
        ...state.strategy,
        ...state.cultura_e_lideranca,
        ...state.experiencia_do_cliente,
        ...state.empreendedorismo_digital,
        ...state.empreendedorismo_digital,
        ...state.tecnologia_digital,
        ...state.agilidade_operacional,
      }
      const keys = Object.keys(questions)
      for (let i = 0; i < keys.length; i += 1) {
        const value = questions[keys[i]];

        if (value === 0) {
          questions[keys[i]] = 'N/A'
        }
      }
      return Object.assign(questions, { ...state.diagnosis, ...state.results })
    }
  }

  return new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js